import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { Add24 } from 'ui/icons/action/Add24';
import { Button } from 'ui/button';
import { BUTTON_SIZES } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';

export const CreateJobModal = () => {
  const { t } = useJobManagerTranslations();
  const { hideModal } = useModalContext();

  return (
    <Modal id="createJobModal" withPortal isModalOpen={true} onClose={hideModal}>
      <ModalHeader onClose={hideModal} autoFocus={false}>
        {t('modal.title.createJob')}
      </ModalHeader>
      <ModalBody>Form</ModalBody>
      <ModalFooter onClose={hideModal}>
        <Button size={BUTTON_SIZES.LARGE}>
          <Add24 />
          {t('button.createJob')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
